import { RCAddress } from 'types/coreEntites/Address';

export interface ContactDetail {
	email: string;
	phoneNumber: string;
	address?:
		| {
				city?: string;
				street?: string;
				streetNum?: string;
				state?: string;
		  }
		| undefined;
	website?: string;
	facebook?: string;
	twitter?: string;
	instagram?: string;
}

export const addressInit: RCAddress = {
	city: '',
	street: '',
	streetNum: '',
	state: '',
};

export const contactDataInit: ContactDetail = {
	email: '',
	phoneNumber: '',
	address: addressInit,
	website: '',
	facebook: '',
	twitter: '',
	instagram: '',
};
